import React, { Suspense } from 'react'
import { faPencil } from '@fortawesome/free-solid-svg-icons'
import Card from 'src/components/Card'
import useToggleState from 'src/hooks/useToggleState'
import Body from './Body'
import List from './List'
import EditModel from './EditModal'

interface DetailsProps {
  id: string
}

const Details: React.FC<DetailsProps> = (props) => {
  const { id } = props
  const [isOpen, , handleToggle] = useToggleState()

  return (
    <>
      <Card
        title='Contract'
        primaryAction={{
          key: 'edit',
          icon: faPencil,
          onClick: handleToggle,
          permissionKey: 'CAT_EDIT'
        }}
      >
        <Suspense fallback={<List contract={undefined} />}>
          <Body id={id} />
        </Suspense>
      </Card>
      <EditModel id={id} isOpen={isOpen} toggle={handleToggle} />
    </>
  )
}

export default Details
